var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-backspace",
    "data-name": "Icon ionic-ios-backspace",
    d: "M28.4,6.75H16.5c-3.368,0-5.279,2.385-7.356,4.364s-5.2,5.134-5.2,5.134a2.1,2.1,0,0,0-.57,1.436,2.148,2.148,0,0,0,.57,1.443s2.474,2.584,5.2,5.189S13.233,28.75,16.5,28.75H28.4a4.942,4.942,0,0,0,4.976-4.88V11.492A4.828,4.828,0,0,0,28.4,6.75ZM27.123,21.369a1.067,1.067,0,0,1,0,1.553,1.2,1.2,0,0,1-1.63,0l-3.8-3.622-3.8,3.622a1.185,1.185,0,0,1-1.63,0,1.028,1.028,0,0,1,0-1.553l3.8-3.622-3.8-3.622a1.028,1.028,0,0,1,0-1.553,1.139,1.139,0,0,1,1.63,0l3.8,3.622,3.8-3.622a1.2,1.2,0,0,1,1.63,0,1.067,1.067,0,0,1,0,1.553l-3.8,3.622Z",
    transform: "translate(-3.375 -6.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.1e02700819dbeb473e87d4531efbf1ea.svg";
export { ForwardRef as ReactComponent };